import React, {Component} from 'react';
import PropTypes from 'prop-types';
import SetupAverageRpm from "./SetupAverageRpm";
import SetupHidePatterns from "./SetupHidePatterns";
import SetupTimezones from "./SetupTimezones";
import SetupShifts from "./SetupShifts";


class SetupContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
        companies: PropTypes.object.isRequired,
        timezones: PropTypes.array.isRequired,
        requestShifts: PropTypes.func.isRequired,
    };

    constructor(props) {

        super(props);

        this.state = {};

        this.translate = this.props.baseData.translate;

    };

    render() {

        return (
            <div>
                <div className="ma-bo-20 clearfix">
                    <SetupAverageRpm
                        baseData={this.props.baseData}
                        companies={this.props.companies}
                    />
                </div>

                <div className="ma-bo-20 clearfix">
                    <SetupHidePatterns
                        baseData={this.props.baseData}
                        companies={this.props.companies}
                    />
                </div>

                <div className="ma-bo-20 clearfix">
                    <SetupTimezones
                        baseData={this.props.baseData}
                        timezones={this.props.timezones}
                    />
                </div>

                <div className="ma-bo-20 clearfix">
                    <SetupShifts
                        baseData={this.props.baseData}
                        requestShifts={this.props.requestShifts}
                    />
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('analysis')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );

    }

}

export default SetupContainer;